import { withAuthenticator } from '@aws-amplify/ui-react';
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AnalyticsManager } from '../../../analytics/AnalyticsManager';
import { TranslationRequest } from '../../../model/Translation';
import TranslationFlow from '../../generic/TransitionFlow';
import TranslationNavBarComponent from '../../generic/TranslationNavBarComponent';
import { Event } from '../../../analytics/AnalyticsEvent';



const TranslationsCreateScreen = () => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [showSignIn, setShowSignIn] = useState(false);
    const navigate = useNavigate();
    const initialized = useRef(false);

    useEffect(() => {
        var isSubscribed = true;
        if (!initialized.current && isSubscribed) {
            initialized.current = true;
            AnalyticsManager.getInstance().track(Event.ENTER_SCREEN.toString(), {title: 'TranslationCreateScreen'})
        }
        return () => {
            isSubscribed = false;
        };
    }, []);

    const onPagesLoaded = (base64Images: string[]) => {
        
    }

    const onTranslationRequestComplete = async (request: TranslationRequest) => {
        navigate(`/translations/myrequests/details?partitionKey=${request.partition_key}&rangeKey=${request.range_key}`)
    }

    return (
        <div className="home-page">
            <TranslationNavBarComponent />
            <main>
                <div className="hero">
                    <TranslationFlow onTranslationRequestComplete={onTranslationRequestComplete} />
                </div>

            </main>

            <footer className="footer">
                <div className="footer-content">
                    <div className="footer-links">
                        <a href="#">Terms</a>
                        <a href="#">Privacy</a>
                        <a href="#">Contact</a>
                    </div>
                    <div className="footer-copyright">
                        <p>&copy; 2024 Certified International Translations INC. All rights reserved.</p>
                    </div>
                </div>
            </footer>
        </div >
    );
};

export default withAuthenticator(TranslationsCreateScreen);